package com.appsyde.shared.modules.account.domain.model

data class Account(
    val id: String,
    val primaryEmail: String,
    val tone: String,
    val signatureEnabled: Boolean,
    val signatureValue: String
)
